
  export default {
    name: "ErrorPage",
    props: {
      code: {
        type: String,
        default: "404"
      }
    },
    data() {
      return {
        error: Number.isNaN(Number(this.code)) ? "Error" : this.code,
        text: {
          title: Number.isNaN(Number(this.code))
            ? this.$t("errorTitle")
            : this.$t("errorTitle" + this.code),
          description: Number.isNaN(Number(this.code))
            ? this.$t("errorReason")
            : this.$t("errorReason" + this.code)
        }
      };
    }
  };
